<template>
  <section class="home" style="background-color: rgb(20, 20, 21)">
    <nav class="home__nav">
      <h4>Available Q1 2025</h4>
    </nav>
    <main class="home__content">
      <div class="home__content__text">
        <h3>Aska © 2025</h3>
        <span>
          <p>Ticketing</p>
          <p>Discover Events</p>
          <p>Guest Management</p>
          <p>E-tickets</p>
          <p>many moree.</p>
        </span>
      </div>
    </main>
    <footer class="home__footer">
      <p>Smart Ticketing, Smarter Events</p>
      <p>
        for more information, and support
        <a href="mailto:support@useaska.xyz">support@useaska.xyz</a>
      </p>
    </footer>
  </section>
</template>

<style scoped lang="scss">
.home {
  &__nav {
    @extend %flex-ac-jb;
    height: calc(6vh + 2.5rem);
    padding: 2.5rem 1.5rem;
    @include respondMax("mobile2x") {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 1rem 1.5rem;
      // background-color: rgb(20, 20, 21);
      p {
        margin-top: 1rem;
      }
    }
    h4 {
      font-family: "PP Neue Montreal", sans-serif;
      font-style: normal;
      font-weight: 450;
      font-size: Max(1rem, 16px);
      line-height: Max(1.5rem, 20px);
      letter-spacing: 0.02em;
      font-feature-settings: "ss06" on, "ss07" on;
      color: #fff;
      pointer-events: none;
      letter-spacing: 2%;
    }
    p {
      @extend %flex-ac;
      gap: 1rem;
      position: relative;
      a {
        font-family: "PP Neue Montreal", sans-serif;
        font-style: normal;
        font-weight: 450;
        font-size: Max(1rem, 16px);
        line-height: Max(1.5rem, 20px);
        text-align: right;
        letter-spacing: 2%m;
        transition: all ease-in-out 0.7s;
        font-feature-settings: "ss06" on, "ss07" on;
        color: #fff;
        position: relative;
        &::after {
          transition: all ease-in-out 0.7s;
          position: absolute;
          width: 0%;
          content: "";
          left: 0;
          bottom: 0;
          height: 2px;
          background: $black;
        }
        &:hover {
          &::after {
            width: 100%;
          }
        }
      }
    }
  }
  &__content {
    height: calc(100vh - 13vh - 5rem);
    @extend %center;
    padding: 0 1.5rem;
    &__text {
      width: Min(949px, 100%);
      text-align: center;
      h3 {
        font-family: "PP Neue Montreal", sans-serif;
        font-style: normal;
        font-weight: 450;
        font-size: Max(6rem, 30px);
        line-height: Max(6.1rem, 30px);
        letter-spacing: -0.04em;
        font-feature-settings: "ss06" on, "ss07" on;
        color: #fff;
        pointer-events: none;
        @media screen and (max-width: 500px) {
          font-size: 40px;
        }
      }
      span {
        @extend %flex-ac-jb;
        margin-top: 0.5rem;
        flex-wrap: wrap;
        @media screen and (max-width: 900px) {
          flex-direction: grid;
          gap: 1rem;
          justify-content: center;
        }
        p {
          font-family: "PP Neue Montreal", sans-serif;
          font-style: normal;
          font-weight: 450;
          font-size: Max(1rem, 16px);
          line-height: Max(1.5rem, 20px);
          letter-spacing: 0.02em;
          font-feature-settings: "ss06" on, "ss07" on;
          color: #fff;
          pointer-events: none;
          letter-spacing: 2%;
        }
      }
    }
  }
  &__footer {
    background-color: rgb(20, 20, 21);
    height: calc(7vh + 2.5rem);
    text-align: center;
    width: 100vw;
    margin: 0 auto;
    padding: 0 1.5rem 2.5rem;
    p {
      font-family: "PP Neue Montreal", sans-serif;
      font-style: normal;
      font-weight: 450;
      font-size: Max(1rem, 16px);
      line-height: Max(1.5rem, 20px);
      letter-spacing: 0.02em;
      font-feature-settings: "ss06" on, "ss07" on;
      color: #fff;
      letter-spacing: 2%;
      a {
        text-decoration: underline;
      }
    }
  }
}
</style>
